import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useRecoilState } from "recoil";
import { rsProgress } from "../../RecoilStates";
import { UseProductVideos } from "./UseProductVideos";
import { useEffect, useState } from "react";

export default function VideoOperation(props) {
  const { updateVideo, createVideo, validateVideo } = UseProductVideos();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [state, setState] = useState({
    productVideoID: null,
    url: "",
    rowIndex: 1,
  });
  const [errorState, setErrorState] = useState({
    url: false,
  });

  useEffect(() => {
    if (props.openDialog?.data) {
      setState({
        id: props.openDialog.data.id,
        productVideoID: props.openDialog.data.productVideoID,
        url: props.openDialog.data.url,
        rowIndex: props.openDialog.data.rowIndex,
      });
    } else {
      var lastRowIndex = Math.max.apply(
        Math,
        props.videos?.map(function (o) {
          return o.rowIndex + 1;
        }),
      );
      setState({
        productVideoID: props.productVideoID,
        url: "",
        rowIndex: lastRowIndex != -Infinity ? lastRowIndex : 1,
      });
    }
  }, [props.videos]);

  return (
    <Dialog
      fullWidth
      onClose={() => {
        props.setOpenDialog({
          show: false,
          data: null,
        });
        setState({
          url: "",
          rowIndex: "",
        });
      }}
      open={props.openDialog.show}
    >
      <DialogTitle>ویرایش اطلاعات</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            mx: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <TextField
            fullWidth
            sx={{
              my: 3,
              textArea: {
                direction: "rtl",
              },
            }}
            value={state.url ? state.url : ""}
            label="لینک ویدیو"
            size="small"
            variant="outlined"
            error={errorState.url}
            onChange={(evt) => {
              setState({
                ...state,
                url: evt.target.value,
              });
            }}
            multiline
            // rows={3}
            maxRows={5}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Button
              sx={{ ml: 1 }}
              color="secondary"
              variant="contained"
              onClick={() => {
                if (state?.id) {
                  if (validateVideo(state, setErrorState) == 200) {
                    setProgress(true);
                    createVideo(state, () => {
                      props.callback();
                    });
                  }
                } else {
                  if (validateVideo(state, setErrorState) == 200) {
                    setProgress(true);
                    updateVideo(state, () => {
                      props.callback();
                    });
                  }
                }
              }}
            >
              ثبت
            </Button>

            <Button
              sx={{ ml: 1 }}
              color="secondary"
              variant="outlined"
              onClick={() => {
                props.setOpenDialog({
                  show: false,
                  data: null,
                });
                setState({
                  url: "",
                  rowIndex: "",
                });
              }}
            >
              انصراف
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
